import { Card, CardContainer } from '@/styles/common';
import React from 'react';
import { Link } from 'react-router-dom';

interface HomeProps {}

const routes: TRoute[] = [
	{ path: '/scenario/demand', title: 'Demand scenarios' },
	{ path: '/scenario/capacity', title: 'Capacity scenarios' },
	{ path: '/scenario/matching', title: 'Balance analysis' },
];

const Home: React.FC<HomeProps> = () => {
	return (
		<CardContainer>
			{routes.map((route) => (
				<Link
					to={route.path}
					state={{ currentPage: route.title }}
					key={route.path}>
					<Card>
						<span>{route.title}</span>
					</Card>
				</Link>
			))}
		</CardContainer>
	);
};

export default Home;
